// M2 QC — data-testid registry.
export const QC = {
  navQC: "nav-qc-jobs",
  queueTable: "qc-queue-table",
  queueRow: (pid) => `qc-queue-row-${pid}`,
  searchInput: "qc-search-input",
  statusFilter: "qc-status-filter",
  mineToggle: "qc-mine-toggle",
  barcodeInput: "qc-barcode-input",
  barcodeGo: "qc-barcode-go",
  pagePrev: "qc-page-prev",
  pageNext: "qc-page-next",

  detailHeader: "qc-detail-header",
  assignSelf: "qc-assign-self-btn",
  unassignBtn: "qc-unassign-btn",
  engineerRemarks: "qc-engineer-remarks",
  batteryHealthInput: "qc-battery-health-input",
  batteryBackupInput: "qc-battery-backup-input",
  ssdHealthInput: "qc-ssd-health-input",
  cosmeticGradeSelect: "qc-cosmetic-grade-select",
  screenGradeSelect: "qc-screen-grade-select",
  actualProcessor: "qc-actual-processor",
  actualRam: "qc-actual-ram",
  actualStorage: "qc-actual-storage",
  actualStorageType: "qc-actual-storage-type",
  photoInput: "qc-photo-input",
  photoPreview: (i) => `qc-photo-preview-${i}`,
  passBtn: "qc-pass-btn",
  failBtn: "qc-fail-btn",
  finishStatusBadge: "qc-finish-status-badge",

  checklistRow: (code) => `qc-checklist-row-${code}`,
  checklistPass: (code) => `qc-check-pass-${code}`,
  checklistFail: (code) => `qc-check-fail-${code}`,
  checklistNA: (code) => `qc-check-na-${code}`,
  checklistValue: (code) => `qc-check-value-${code}`,
  checklistGrade: (code) => `qc-check-grade-${code}`,
  checklistRemarks: (code) => `qc-check-remarks-${code}`,
};
